import EastIcon from '@mui/icons-material/East'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import { Container, Box, Checkbox, Grid } from '@mui/material'
import { AlertColor } from '@mui/material/Alert'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useClosestPayments } from '@src/api/payment-api/payment-hoocks'
import { usePostPaymentSpread } from '@src/api/payment-api/spread-payment-api'
import { CustomButton, CustomSnackbar, PageSpinner, PaymentSpreadInfo, TitleSection } from '@src/components'
import { ChangeEvent, useState, SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

const RetardedPayement = () => {
  const { t } = useTranslation()

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const [agreeToTerms, setAgreeToTerms] = useState<boolean>(false)
  const [contactRequested, setContactRequested] = useState<boolean>(false)

  const { id: routeId, numPayments } = useParams<{ id?: string; numPayments?: string }>()
  const id = routeId ?? ' '
  const today = new Date().toISOString()
  const [closestPayments, isLoadingClosest] = useClosestPayments(+(numPayments ?? 2), id, today)

  const [submitPaymentSpread, isPending] = usePostPaymentSpread()

  const handleAgreeToTermsChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAgreeToTerms(event.target.checked)
  }

  const handleContactRequestedChange = (event: ChangeEvent<HTMLInputElement>) => {
    setContactRequested(event.target.checked)
  }

  const reprogramPayment = () => {
    if (!closestPayments || closestPayments.length === 0 || !id || !agreeToTerms) {
      setSnackbar({
        open: true,
        message: t('payment.allFieldsMustBeFilled'),
        severity: 'error',
      })
      return
    }

    const firstPayment = closestPayments[0]
    const formattedActualDate = new Date(firstPayment.plannedOnDateUTC).toISOString()
    const formattedNewDate = new Date(firstPayment.plannedOnDateUTC).toISOString()

    submitPaymentSpread({
      amount: firstPayment.amount,
      actualDate: formattedActualDate,
      newDate: formattedNewDate,
      contactCustomer: contactRequested,
      loanId: id,
    })
      .then(() => {
        setSnackbar({
          open: true,
          message: t('loanStatus.paymentSpread'),
          severity: 'success',
        })
      })
      .catch(() => {
        setSnackbar({
          open: true,
          message: t('loanStatus.paymentSpreadError'),
          severity: 'error',
        })
      })
  }
  const handleCloseSnackbar = (_event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return
    setSnackbar((snak) => ({
      ...snak,
      open: false,
    }))
  }

  if (isLoadingClosest) return <PageSpinner isLoading={true} />

  const renderSection = (title: string, state: boolean, setState: (event: ChangeEvent<HTMLInputElement>) => void) => {
    return (
      <Box sx={{ mt: '1rem' }}>
        <FormControlLabel control={<Checkbox checked={state} onChange={setState} />} label={t(title)} />
      </Box>
    )
  }

  return (
    <>
      <TitleSection title={t('payment.loan')} />
      <Container component="main" sx={{ flexGrow: 1 }}>
        <Grid container>
          <Grid size={{ xs: 12, md: 9, lg: 9 }}>
            <Box
              sx={{
                color: 'white',
                padding: {
                  xs: '0 1px',
                  sm: '0 20px',
                },
                boxSizing: 'border-box',
              }}
            >
              <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity as AlertColor}
                onClose={handleCloseSnackbar}
              />
              <Box sx={{ mt: '1rem' }}>
                <NotificationsActiveIcon />
                <span>{t('payment.attention')}</span>
              </Box>

              <PaymentSpreadInfo payments={closestPayments} />

              {renderSection('payment.confirmTerms', agreeToTerms, handleAgreeToTermsChange)}
              {renderSection('payment.contactForChanges', contactRequested, handleContactRequestedChange)}

              <Box sx={{ mt: '1rem' }}>
                <CustomButton
                  title={t('payment.applyChanges')}
                  onClick={reprogramPayment}
                  Icon={EastIcon}
                  isPending={isPending}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default RetardedPayement
